import { Component, Input } from '@angular/core';
import { SharedZorroModule } from '../../../shared-zorro.module';
import { CommonModule } from '@angular/common';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-table-header-setting',
  standalone: true,
  imports: [CommonModule, SharedZorroModule, NzCheckboxModule, DragDropModule],
  templateUrl: './table-header-setting.component.html',
  styleUrl: './table-header-setting.component.less',
})
export class TableHeaderSettingComponent {
  @Input() tableHeader: any[] = [];

  constructor() {}

  drop(event: any) {
    moveItemInArray(this.tableHeader, event.previousIndex, event.currentIndex);
  }
}
